/**
 * CEC sync stores rated power in kW-scale values: batteries map RatedDCPower into
 * Wattage and NominalMaxPowerKw; inverters map Nominal_AC_Power_W__c into Wattage
 * but that source is also kW-scale in practice (e.g. 3 not 3000). List as kW.
 */

function trimKwDigits (n) {
	if (Number.isInteger(n) || Math.abs(n - Math.round(n)) < 1e-6) {
		return String(Math.round(n))
	}
	return String(Number(n.toFixed(4)))
		.replace(/(\.\d*?[1-9])0+$/, '$1')
		.replace(/\.0+$/, '')
}

/**
 * @param {{ wattage?: number|string|null, nominalMaxPowerKw?: number|string|null }} model
 * @returns {string|null} e.g. "6 kW", or null if no power fields
 */
export function formatProductPowerLine (model) {
	const w = model.wattage
	const hasW = w != null && w !== ''
	const k = model.nominalMaxPowerKw
	const hasK = k != null && k !== ''

	if (hasK) {
		const n = Number(k)
		if (!Number.isNaN(n)) return `${trimKwDigits(n)} kW`
	}

	if (hasW) return `${w} kW`
	return null
}
